import React, { useState } from 'react'
import { Button, Col, Row } from 'antd'
import { BBDTag, DataItem, Texto, addCommasToNumber } from '@gravitate-js/excalibrr'
import { formatters } from '@utils/intl/dateTimeFormatters'
import { SupplyDifferences } from '@components/_SiteWide/AuditHistory/SupplyDifferences'
export const SupplyActionDetails = ({ details, detailKeys, isRequestedChangeAudit }) => {
  const [viewingSupplyDifferences, setViewingSupplyDifferences] = useState(false)
  const isBestOption = details.is_best_supply ? 'Yes' : 'No'
  const enableShowSupplyDifferences = detailKeys.length > 0

  const handleViewDetails = () => {
    setViewingSupplyDifferences(!viewingSupplyDifferences)
  }
  return (
    <>
      <div className='details-container'>
        {isRequestedChangeAudit ? (
          <Row flex justify='space-between'>
            <Col>
              <DataItem label='Reason Code'>{details.reason ? details.reason : 'N/A'}</DataItem>
            </Col>
            <Col align='right' className='vertical-flex-center'>
              {enableShowSupplyDifferences && (
                <Button type='link' style={{ padding: '0', width: '100px' }} onClick={handleViewDetails}>
                  {!viewingSupplyDifferences ? 'View Differences' : 'Hide Differences'}
                </Button>
              )}
            </Col>
          </Row>
        ) : (
          <>
            <Row flex justify='space-between'>
              <Col span={12}>
                <DataItem label='Was Best Option?'>{isBestOption}</DataItem>
              </Col>
              <Col span={12} align='right'>
                <DataItem label='Reason Code'>{details.reason ? details.reason : 'N/A'}</DataItem>
              </Col>
            </Row>
            <Row flex justify='space-between'>
              {details.price_difference && (
                <Col span={14}>
                  <DataItem label='Price Difference'>$ {details.price_difference.toFixed(2)}</DataItem>
                </Col>
              )}
              <Col span={10} push={5} align='right' className='vertical-flex-center'>
                {enableShowSupplyDifferences && (
                  <Button type='link' style={{ padding: '0', width: '100px' }} onClick={handleViewDetails}>
                    {!viewingSupplyDifferences ? 'View Differences' : 'Hide Differences'}
                  </Button>
                )}
              </Col>
            </Row>
          </>
        )}
      </div>
      {viewingSupplyDifferences && (
        <SupplyDifferences oldSupply={details.old_supply_option} newSupply={details.new_supply_option} />
      )}
    </>
  )
}
